
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/lyrics",
      function () {
        return require("private-next-pages/features/lyrics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/lyrics"])
      });
    }
  